import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useFileUploaderStyles = makeStyles({
  button: {
    backgroundColor: designTokens.neutral.white,
    color: designTokens.neutral[600],
    minWidth: "auto",
    ...shorthands.padding(designTokens.spacing[1]),
    ":hover": {
      backgroundColor: designTokens.neutral[100],
      color: designTokens.accent[500],
    },
  },
});
